import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import PronunciationExercises from "../../../../../edu_lms/components/Game/PronunciationExercises_2";

const IMG_002 = ({ activity, bookId }) => {
	return (
		<GameContainer data={activity}>
			<PronunciationExercises data={activity} />
		</GameContainer>
	);
};

export default IMG_002;
